import { useState } from "react";
import { Address } from "../models/company";

interface AddressAutocompleteProps {
  onAddressSelected?: (place: Address) => void;
  placeholder?: string;
  inputClassName?: string;
  dropdownClassName?: string;
}

const AddressAutocomplete: React.FC<AddressAutocompleteProps> = ({
  onAddressSelected,
  placeholder = "Enter address",
  inputClassName,
  dropdownClassName,
}) => {
  const [inputValue, setInputValue] = useState("");
  const [predictions, setPredictions] = useState<any[]>([]);

  const acceptedTypes = new Set(["street_address", "premise", "subpremise"]);

  const handleAddressChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(event.target.value);
    console.log(event.target.value);
    if (event.target.value.length < 3) {
      setPredictions([]);
      return;
    }
    fetch("https://places.googleapis.com/v1/places:autocomplete", {
      headers: {
        "Content-Type": "application/json",
        "X-Goog-Api-Key": "AIzaSyCV_uprTUyvIrWmycUo3VnxmjZrhc-ZeaY",
      },
      method: "POST",
      body: JSON.stringify({
        input: event.target.value,
        // unfortunately, Google Places API does not support restricting to only addresses.
        // the below is a "hint" to prefer addresses, but it still may return other types.
        includedPrimaryTypes: Array.from(acceptedTypes),
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (!data.suggestions) {
          setPredictions([]);
          return;
        }
        setPredictions(
          data.suggestions
            .map((s: any) => s.placePrediction)
            .filter(
              (s: any) =>
                s.placeId &&
                !s.types.includes("postal_code") &&
                s.types.some((t: string) => acceptedTypes.has(t)),
            ),
        );
        console.log(
          "Predictions:",
          data.suggestions.map((s: any) => s.placePrediction),
        );
        console.log(data);
      })
      .catch((error) => {
        console.error("Error fetching address suggestions:", error);
      });
  };

  const handleAddressSelect = (prediction: any) => {
    fetch(`https://places.googleapis.com/v1/places/${prediction.placeId}`, {
      headers: {
        "X-Goog-Api-Key": process.env.REACT_APP_GOOGLE_PLACES_API_KEY || "",
        "X-Goog-FieldMask": "postalAddress,addressComponents",
      },
    })
      .then((response) => response.json())
      .then((data) => {
        console.log("Selected address details:", data);
        const address: Address = {
          streetLines: data.postalAddress.addressLines || [],
          city: data.postalAddress.locality,
          postalCode: data.postalAddress.postalCode,
          stateOrProvinceCode: data.postalAddress.administrativeArea,
          countryCode: data.postalAddress.regionCode,
        };
        if (onAddressSelected) {
          onAddressSelected(address);
        }
      })
      .catch((error) => {
        console.error("Error fetching address details:", error);
      });
  };

  return (
    <div className="relative">
      <input
        type="text"
        value={inputValue}
        onChange={handleAddressChange}
        placeholder={placeholder}
        className={inputClassName || "border-2 rounded p-2 w-full"}
      />
      {predictions.length > 0 && (
        <ul
          className={
            dropdownClassName ||
            "absolute z-10 bg-white border border-gray-300 w-full"
          }
        >
          {predictions.map((prediction) => (
            <li
              key={prediction.placeId}
              onClick={() => handleAddressSelect(prediction)}
              className="p-2 hover:bg-gray-200 cursor-pointer"
            >
              {prediction.structuredFormat?.mainText?.text || ""}{" "}
              <span className="text-gray-500">
                {prediction.structuredFormat?.secondaryText?.text || ""}
              </span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default AddressAutocomplete;
